import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { toastHelper } from '../../util/toastHelper'
import ButtonCustom from '../atoms/button/ButtonCustom'

// A reusable button component that triggers a Redux dispatch and enters a cooldown state after being clicked
export const CooldownButton = ({
	buttonText, // Text to show on the button when not in cooldown
	cooldownSeconds, // Duration of the cooldown in seconds
	dispatchFunction, // Redux action creator to dispatch
	dispatchData, //Payload for the dispatched action. json object recommended
}) => {
	const dispatch = useDispatch()

	const [cooldown, setCooldown] = useState(0) // Tracks remaining cooldown time
	const [canClick, setCanClick] = useState(true) // Controls if the button is currently clickable

	// Handler for button click
	const handleClick = () => {
		if (!canClick) return // Prevent interaction if still in cooldown

		// call fetch function if possible
		if (dispatchFunction) {
			dispatch(dispatchFunction(dispatchData))
		} else {
			return toastHelper('Invalid input', 'error')
		}

		// Enter cooldown state
		setCanClick(false)
		setCooldown(cooldownSeconds)
	}

	// Effect to decrement the cooldown timer every second
	useEffect(() => {
		if (cooldown === 0) {
			setCanClick(true) // Re-enable the button when cooldown ends
			return
		}

		const timer = setInterval(() => {
			setCooldown((prev) => {
				if (prev <= 1) {
					clearInterval(timer)
					return 0
				}
				return prev - 1
			})
		}, 1000)

		// Clear interval on unmount or cooldown change
		return () => clearInterval(timer)
	}, [cooldown])

	return (
		<ButtonCustom
			variant="default"
			// className={canClick ? '' : styles.button} // Optionally apply disabled styling
			onClick={handleClick}
			disabled={!canClick} // Disable the button during cooldown
			style={{ flex: '0 0 auto' }}
		>
			{canClick ? buttonText : `Resend in ${cooldown}s`}
		</ButtonCustom>
	)
}
